<script>
	// No special scripting required unless dynamic behavior is added

	import { handleNav } from "$lib/utilities/handleNav";
	import StarRating from "$lib/components/StarRating.svelte";

	export let reviewLink;
	export let rating;
	export let userRatingCount;
	export let statTitle;
	export let ratingCountLabel;
	export let reviewAction;
</script>

{#if !isNaN(rating)}
	<div class="stats shadow-lg bg-base-300 rounded-xl">
		<div class="stat">
			<h3 class="stat-title">{statTitle}</h3>
			<div class="stat-value">
				<div>
					{Number(rating).toFixed(1)}
				</div>
				<StarRating max{5} rating={Number(rating)} />
			</div>
			<h3 class="stat-desc">
				{userRatingCount}
				{ratingCountLabel}
			</h3>
		</div>
	</div>
{/if}

{#if reviewLink}
	<div class="mt-4">
		<div
			class="btn sm:btn-xl hover-ripple rounded-xl bg-base-300 shadow-lg"
		>
			<a
				href={reviewLink}
				onclick={handleNav}
				class={`whitespace-nowrap`}
			>
				{reviewAction}
			</a>
		</div>
	</div>
{/if}
